import { shouldAnimate, transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { contentStyles, paragraphSmall } from '@helpers/typography';
import { DotsStyles } from '@stories/Components/Misc/Carousels/Carousel/Dots/Dots.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
const Container = styled.div `
  --speed: 10s;
  --itemGap: 20px;

  display: flex;
  align-items: center;
  white-space: nowrap;
  background-color: ${brand.blue.navy};
  height: var(--announcementHeight);
  overflow: hidden;

  @media ${until(Device.TabletLarge)} {
    padding-left: var(--sitePadding);
  }

  @media ${from(Device.TabletLarge)} {
    gap: 24px;
    grid-column: 2 / span 1;
  }
`;
const AnnouncementTrack = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: flex;
    gap: var(--itemGap);

    ${shouldAnimate(css `
      animation: scrolling var(--speed) linear infinite;
    `)}

    @keyframes scrolling {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(calc(-50% - (var(--itemGap) * 0.5)));
      }
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: grid;
  }
`;
const AnnouncementItem = styled.div `
  ${contentStyles};

  --linkColour: ${brand.green.default};

  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  p {
    ${paragraphSmall};
    ${fonts.proximaNova.medium};

    margin: 0;
    color: ${brand.global.white};

    a {
      ${fonts.proximaNova.bold};

      color: var(--linkColour);
    }
  }

  &[data-type=${ContentType.Intermediaries}] {
    --linkColour: ${brand.green.light};
  }

  &[data-type=${ContentType.Savings}] {
    --linkColour: ${brand.blue.light};
  }

  @media ${until(Device.TabletLarge)} {
    &::before {
      content: '\\2022';
      position: absolute;
      top: 50%;
      left: 0;
      width: var(--itemGap);
      text-align: center;
      transform: translate(-100%, -50%);
      color: var(--linkColour);
    }
  }

  @media ${from(Device.TabletLarge)} {
    ${transition('opacity', 1)};

    grid-area: 1 / 1 / 1 / 1;

    &[data-duplicate] {
      display: none;
    }

    &[data-active='false'] {
      opacity: 0;
      pointer-events: none;
    }
  }
`;
const AnnouncementControls = styled.div `
  --dotsWidth: calc(100% - 28px);
  --width: 4ch;

  display: none;

  @media ${from(Device.TabletLarge)} {
    display: grid;
    color: ${brand.global.white};
    grid-template-columns: 24px 1fr 24px;

    ${DotsStyles.Dots} {
      grid-column: 1 / span 3;
      min-width: var(--dotsWidth);
      margin: 0 auto;
      width: var(--dotsWidth);
    }
  }
`;
const AnnouncementButton = styled.button `
  ${ButtonReset};
  ${transition('transform')};

  display: grid;
  place-content: center;
  width: 24px;
  height: 24px;
  color: currentColor;

  > svg {
    display: block;
    width: 10px;
    transform: rotate(-90deg);
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 2px;
    outline-width: 1px;
    outline-style: solid;
  }

  &:nth-of-type(1) {
    transform: scale(-1);
  }

  &:hover {
    transform: scale(1.15);
  }

  &:nth-of-type(1):hover {
    transform: scale(-1.15);
  }
`;
const AnnouncementCount = styled.p `
  ${paragraphSmall};

  margin: 0;
  min-width: var(--width);
  text-align: center;
`;
const AnnouncementBarStyles = {
    Container,
    AnnouncementButton,
    AnnouncementControls,
    AnnouncementCount,
    AnnouncementItem,
    AnnouncementTrack,
};
export default AnnouncementBarStyles;
